import Swiper, { Navigation } from 'swiper';

Swiper.use([Navigation]);

interface EventSliderProps {
    el: HTMLElement;
}

const EventsBlock = ({ el }: EventSliderProps): void => {
    const sliderSwiper = new Swiper(el, {
        init: false,
        autoHeight: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: false,
        breakpoints: {
            0: {
                slidesPerView: 1.2,
                spaceBetween: 16,
                slidesOffsetBefore: 16,
                slidesOffsetAfter: 16,
            },
            768: {
                slidesPerView: 2.2,
                spaceBetween: 16,
            },
            1280: {
                slidesPerView: 3,
                spaceBetween: 16,
            },
        },
    });

    sliderSwiper.init();
};

export default EventsBlock;
